module.exports = __webpack_public_path__ + "img/undraw_Ride_a_bicycle.be41606c.svg";